import React from "react";
import { useTranslation } from "react-i18next";

import { FetchStatus } from "@src/types/api/FetchStatus.types";

import { ReactComponent as IconSuccess } from "@images/icons/icon-success.svg";
import { ReactComponent as IconWarning } from "@images/icons/icon-warning.svg";

import "./SendingStatusBadge.scss";

interface SendingStatusBadgeProps {
  status?: FetchStatus;
}

const SendingStatusBadge = ({ status = "idle" }: SendingStatusBadgeProps) => {
  const { t } = useTranslation("common");

  if (status === "success") {
    return (
      <div className="sending-status-badge">
        <IconSuccess /> <p>{t("sendingStatus.success")}</p>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="sending-status-badge">
        <IconWarning /> <p className="warning">{t("sendingStatus.failed")}</p>
      </div>
    );
  }

  return <></>;
};

export default SendingStatusBadge;
